import { Check, Loader2, AlertCircle } from 'lucide-react'

interface AutosaveIndicatorProps {
  state: 'idle' | 'saving' | 'saved' | 'error'
  lastSavedAt?: string
}

export function AutosaveIndicator({ state, lastSavedAt }: AutosaveIndicatorProps) {
  const getIcon = () => {
    switch (state) {
      case 'saving':
        return <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
      case 'saved':
        return <Check className="h-4 w-4 text-[#2E7D5B]" aria-hidden="true" />
      case 'error':
        return <AlertCircle className="h-4 w-4 text-destructive" aria-hidden="true" />
      default:
        return null
    }
  }

  const getText = () => {
    switch (state) {
      case 'saving':
        return 'Saving...'
      case 'saved':
        if (lastSavedAt) {
          const time = new Date(lastSavedAt).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          })
          return `Saved at ${time}`
        }
        return 'Saved'
      case 'error':
        return 'Save failed'
      default:
        return ''
    }
  }

  if (state === 'idle') return null

  return (
    <div
      className="flex items-center gap-2 text-sm"
      aria-live="polite"
      aria-atomic="true"
      role="status"
    >
      {getIcon()}
      <span className={state === 'error' ? 'text-destructive' : 'text-muted-foreground'}>
        {getText()}
      </span>
    </div>
  )
}
